import { render } from "@/components/organisms/individualWorkSupport/IndividualWorkSupport.html?vue&type=template&id=f0ba359a&external"
import script from "@/components/pages/specialFeature/spWorkSupport/SpWorkSupport.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spWorkSupport/SpWorkSupport.js?vue&type=script&lang=js&external"

import "@/components/organisms/individualWorkSupport/IndividualWorkSupport.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__